import { ReactElement, useEffect, useState } from 'react';
import { Form } from 'react-bootstrap';
import './ToplineNumber.scss';

interface ToplineNumberProps {
  label: string | ReactElement;
  value?: number;
  formatter?: (value: number | null) => string;
  editable?: boolean;
  onEditParams?: {
    valueFormatter: (value: number) => string;
    valueParser: (formattedStr: string) => number;
  };
  onEdit?: (value: number) => void;
}

export const ToplineNumber = ({
  label,
  value,
  formatter,
  editable,
  onEditParams = {
    valueFormatter: (num: number) => num.toString(),
    valueParser: (formattedStr: string) => parseFloat(formattedStr)
  },
  onEdit
}: ToplineNumberProps) => {
  const [editedValue, setEditedValue] = useState<number>(parseFloat((value || 0).toFixed(2)));
  const { valueFormatter, valueParser } = onEditParams;

  useEffect(() => {
    if (onEdit) {
      onEdit(editedValue);
    }
  }, [editedValue, onEdit]);

  return (
    <div className='youtube-plan-topline-number'>
      <div className='youtube-plan-topline-number-label'>{label}</div>
      {editable && onEdit ? (
        <Form.Control
          className='value-input'
          placeholder={`Input ${label}`}
          value={valueFormatter(editedValue)}
          onChange={e => {
            const parsedNumber = valueParser(e.target.value);
            if (parsedNumber != null && parsedNumber > 0) {
              setEditedValue(parsedNumber);
            }
          }}
        />
      ) : (
        <div className='youtube-plan-topline-number-value'>
          {formatter ? formatter(value || null) : value}
        </div>
      )}
    </div>
  );
};
